import { LinearGradient } from "expo-linear-gradient";
import React, { useEffect, useState } from "react";
import {
  Image,
  Modal,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { toast } from "react-toastify";
import { base_url, endpoints } from "../../../../Api/configs";
import { ShowLoader } from "../../../../common/ShowLoader";
import {
  beltConvert,
  ConvertTokensToBelts,
  createTransaction,
} from "../../../../services/profileAPI";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";
import { storeUserActivity, ACTIVITY_TYPES } from "../../../../services/activityService";
export default function CornfirmPurchaseBeltModal(props) {
  const {
    setArrBeltMedalType,
    accessToken,
    showModal = false,
    arrBeltMedalType,
    setShowModal,
    selectedBelt,
    dataSelectedBelt = {},
    userBalanceData,
    jumpToPurchaseToken,
    setRefreshAPICall,
    numberOfBelts = "1",
    insufficientStakesError = null,
    eventID = null, // Optional eventID for activity tracking
  } = props;

  // Debug: Log eventID when modal opens
  console.log("📦 CornfirmPurchaseBeltModal opened with eventID:", eventID, "| showModal:", showModal);

  const onCloseClick = () => {
    setShowModal(false);
    selectedBelt();
  };

  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [showLoader, setShowLoader] = useState(false);
  // Bronze belt price is always 550 tokens (static)
  const BRONZE_BELT_PRICE = 550;
  const beltPrice = BRONZE_BELT_PRICE;

  const token = beltPrice * Number(numberOfBelts);
  // Initialize count with required belts if there's an insufficient stakes error
  const [count, setCount] = useState(() => {
    if (insufficientStakesError && numberOfBelts) {
      return parseInt(numberOfBelts) || 0;
    }
    return 0;
  });
  const purchaseTokenAmount = (beltPrice * count).toFixed(2);
  const newPurchaseTokenAmount = (beltPrice * (count + 1)).toFixed(2);

  const increment = () => {
    if (parseFloat(newPurchaseTokenAmount) <= userBalanceData?.balance) {
      setCount((prev) => prev + 1);
    } else {
      toast.error(
        "You don't have enough tokens to purchase this amount of belts"
      );
    }
  };
  const decrement = () => {
    if (count > 0) {
      setCount((prev) => prev - 1);
    }
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <View style={styles.mainView}>
          {/* Header view */}

          <View style={styles.headerView}>
            <View style={{ flex: 1 }}>
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.BOLD_ANYBODY_16
                    : AppFontStyle.BOLD_ANYBODY_32,
                  { color: AppColors.white },
                ]}
              >
                {insufficientStakesError ? "Match Belts" : "Buy Bronze Belt"}
              </Text>

              {insufficientStakesError && (
                <View
                  style={{
                    backgroundColor: AppColors.red_ED1F24 + "20",
                    borderWidth: 1,
                    borderColor: AppColors.red_ED1F24,
                    borderRadius: 8,
                    padding: 10,
                    marginTop: 10,
                  }}
                >
                  <Text
                    style={[
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? AppFontStyle.BOLD_ANYBODY_12
                        : AppFontStyle.BOLD_ANYBODY_14,
                      { color: AppColors.white },
                    ]}
                  >
                    Insufficient Balance
                  </Text>
                  <Text
                    style={[
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? AppFontStyle.REGULAR_ANYBODY_10
                        : AppFontStyle.REGULAR_ANYBODY_12,
                      { color: AppColors.white, marginTop: 5 },
                    ]}
                  >
                    {insufficientStakesError.fullMessage ||
                      `You need ${insufficientStakesError.requiredAmount} ${insufficientStakesError.beltType} belts to accept this challenge`}
                  </Text>
                </View>
              )}

              <Text
                style={[
                  deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.REGULAR_ANYBODY_12
                    : AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    color: AppColors.white,
                    marginTop:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? 8
                        : 5,
                  },
                ]}
              >
                {insufficientStakesError
                  ? `You need to select ${numberOfBelts ||
                  insufficientStakesError?.requiredAmount ||
                  3
                  } bronze belts to match the challenge belts`
                  : "Purchase Bronze Belts using KO Tokens"}
              </Text>
              <TouchableOpacity
                onPress={() => {
                  setShowModal(false);
                  navigateToScreen(navigation, AppScreens.HelpScreen, {
                    tab: "tokenBelts&Coins",
                  });
                }}
              >
                <Text
                  style={[
                    deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.REGULAR_ANYBODY_12
                      : AppFontStyle.REGULAR_ANYBODY_14,
                    {
                      color: AppColors.white,
                      textDecorationLine: "underline",
                      marginTop: 16,
                    },
                  ]}
                >
                  Learn about Belts system
                </Text>
              </TouchableOpacity>
            </View>
            <View
              style={{
                flexDirection:
                  deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                    ? "row"
                    : "column",
                justifyContent:
                  deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                    ? "space-between"
                    : "flex-start",
                alignItems:
                  deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                    ? "center"
                    : "flex-start",
              }}
            >
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  { color: AppColors.white },
                ]}
              >
                Your KO Tokens
              </Text>
              <View style={styles.tokenWrapper}>
                <View style={styles.tokenItemWrapper}>
                  <Image
                    source={AppImages.Ko_Token}
                    style={{
                      width: 24,
                      height: 24,
                      resizeMode: "contain",
                    }}
                  />
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_20,
                      {
                        color: AppColors.white,
                        alignSelf: "center",
                      },
                    ]}
                  >
                    {userBalanceData?.balance || userBalanceData?.koCoins || 0}
                  </Text>
                </View>
                <TouchableOpacity
                  activeOpacity={0.5}
                  onPress={() => {
                    jumpToPurchaseToken(true);
                    setShowModal(false);
                  }}
                  style={{
                    backgroundColor: AppColors.blue_2196F3,
                    borderRadius: 6,
                    paddingHorizontal: 12,
                    paddingVertical: 8,
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 5,
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_12,
                      { color: AppColors.white },
                    ]}
                  >
                    + Buy KO Tokens
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>

          <View style={styles.divider} />
          <ScrollView
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{ flexGrow: 1, alignItems: "center" }}
            style={{ flex: 1, width: "100%" }}
          >
            <View style={{ alignItems: "center", width: "100%" }}>
              <LinearGradient
                colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 1 }}
                style={styles.beltWrapper}
              >
                <View
                  style={{
                    alignItems: "center",
                    marginBottom: 30,
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_20,
                      { color: AppColors.white, marginBottom: 20 },
                    ]}
                  >
                    Bronze
                  </Text>
                  <Image
                    source={AppImages.icBronzeBelt}
                    style={{
                      width: 120,
                      height: 120,
                      resizeMode: "contain",
                      marginBottom: 15,
                    }}
                  />
                  <View
                    style={{
                      backgroundColor: AppColors.purple_453B50,
                      borderRadius: 5,
                      paddingHorizontal: 12,
                      paddingVertical: 8,
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Image
                        source={AppImages.Ko_Token}
                        style={{
                          width: 16,
                          height: 16,
                          marginRight: 5,
                        }}
                      />
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_14,
                          { color: AppColors.white },
                        ]}
                      >
                        {beltPrice}
                      </Text>
                    </View>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.white },
                      ]}
                    >
                      |
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.white },
                      ]}
                    >
                      £{5}
                    </Text>
                  </View>
                </View>

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 20,
                  }}
                >
                  <Text
                    style={[
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? AppFontStyle.REGULAR_ANYBODY_14
                        : AppFontStyle.REGULAR_ANYBODY_18,
                      { color: AppColors.white },
                    ]}
                  >
                    Type numbers of belts to buy
                  </Text>
                  <View style={styles.counterWrapper}>
                    <TouchableOpacity
                      style={[
                        styles.button,
                        count === 0 && styles.disabledButton,
                      ]}
                      onPress={decrement}
                      disabled={count === 0}
                    >
                      <Image
                        source={AppImages.icMinusIcon}
                        style={{
                          width: 20,
                          height: 3,
                          tintColor: AppColors.purple_453B50,
                        }}
                      />
                    </TouchableOpacity>
                    <TextInput
                      placeholder={count.toString()}
                      multiline={false}
                      placeholderTextColor={AppColors.white}
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_16,
                        {
                          color: AppColors.white,
                          backgroundColor: AppColors.black_121212,
                          width: 40,
                          height: 30,
                          textAlign: "center",
                        },
                      ]}
                      onChangeText={(text) => {
                        if (text === "" || /^\d+$/.test(text)) {
                          const num = text === "" ? 0 : parseInt(text, 10);
                          const totalCost = beltPrice * num;
                          if (totalCost <= userBalanceData?.balance) {
                            setCount(num);
                          } else {
                            toast.error(
                              "You don't have enough tokens for this amount"
                            );
                          }
                        }
                      }}
                      value={count === 0 ? "" : count.toString()}
                      keyboardType="numeric"
                      maxLength={3}
                    />
                    <TouchableOpacity
                      style={[
                        styles.button,
                        parseFloat(purchaseTokenAmount) + 65 >=
                        userBalanceData?.balance && styles.disabledButton,
                      ]}
                      disabled={
                        parseFloat(purchaseTokenAmount) >=
                        userBalanceData?.balance
                      }
                      onPress={increment}
                    >
                      <Image
                        source={AppImages.icPlusIcon}
                        style={{
                          width: 20,
                          height: 20,
                          tintColor: AppColors.purple_453B50,
                        }}
                      />
                    </TouchableOpacity>
                  </View>
                </View>

                {count > 0 && (
                  <View
                    style={{
                      backgroundColor: AppColors.black_282828,
                      borderRadius: 8,
                      padding: 15,
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_16,
                        { color: AppColors.white },
                      ]}
                    >
                      You have selected {count} bronze Belts
                    </Text>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <View
                        style={{
                          backgroundColor: AppColors.purple_453B50,
                          borderRadius: 5,
                          paddingHorizontal: 10,
                          paddingVertical: 5,
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Image
                          source={AppImages.Ko_Token}
                          style={{
                            width: 15,
                            height: 15,
                            marginRight: 4,
                          }}
                        />
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_14,
                            { color: AppColors.white },
                          ]}
                        >
                          {purchaseTokenAmount}
                        </Text>
                      </View>
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_14,
                          { color: AppColors.white },
                        ]}
                      >
                        £{(5 * count).toFixed(2)}
                      </Text>
                    </View>
                  </View>
                )}
              </LinearGradient>
            </View>
          </ScrollView>
          {/* Buy Button */}
          <View style={styles.buttonWrapper}>
            <TouchableOpacity
              style={styles.closeButton}
              onPress={() => {
                setShowModal(false);
              }}
            >
              <Text
                style={[AppFontStyle.BOLD_ANYBODY_12, styles.closeButtonText]}
              >
                Cancel
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.confirmButton, { opacity: count === 0 ? 0.5 : 1 }]}
              disabled={count === 0}
              onPress={() => {
                if (userBalanceData && dataSelectedBelt) {
                  if (userBalanceData?.balance < token) {
                    toast.error(
                      "You don't have enough tokens to purchase this belt"
                    );
                    return;
                  }
                }
                paymentTokensToBeltsAPI({
                  successCallBack: () => {
                    const tempArr = [...arrBeltMedalType];
                    // currently only bronze belt is available for purchase
                    // so we are hardcoding the index
                    // TODO :if we have multiple belts then we need to find the index of the selected belt
                    const index = tempArr.findIndex(
                      (item) => item.title === "Bronze"
                    );
                    tempArr[index].purchaseToken = purchaseTokenAmount;
                    tempArr[index].purchasedBeltAmount = count;
                    setArrBeltMedalType(tempArr);
                    // Call onCloseClick AFTER updating state so BeltPurchaseSuccessModal has correct data
                    onCloseClick();
                  },
                });
                // onCloseClick();
              }}
            >
              <Text
                style={[AppFontStyle.BOLD_ANYBODY_12, styles.confirmButtonText]}
              >
                {insufficientStakesError
                  ? "Confirm belts match"
                  : "Confirm purchase"}
              </Text>
            </TouchableOpacity>
          </View>
        </View>

        {/* Show Loader */}
        {<ShowLoader showIndicater={showLoader} />}
      </View>
    </Modal>
  );

  // TODO : To set Purchase For all Types of Belts (Currently only Bronze Belt Purchase is available)
  async function paymentTokensToBeltsAPI({ successCallBack }) {
    setShowLoader(true);

    try {
      const beltTitle = arrBeltMedalType[1]
        ? arrBeltMedalType[1].title
        : "Bronze";
      const totalTokenCost = beltPrice * count;

      const data = await ConvertTokensToBelts(
        accessToken,
        count,
        beltTitle,
        totalTokenCost
      );
      setShowLoader(false);

      if (data.statusCode === 200) {
        toast.success(data.body.message);
        setRefreshAPICall(true);
        await createNewTransaction(
          accessToken,
          totalTokenCost,
          count,
          beltTitle
        );
        // Track belt purchase activity (fire and forget)
        console.log("🎯 Belt purchase tracking - eventID:", eventID, "| beltTitle:", beltTitle, "| count:", count);
        // Always attempt to call the API - use eventID or fallback to empty string for debugging
        const trackingEventId = eventID || "";
        console.log("🚀 Calling storeUserActivity for BELTS_PURCHASED with eventId:", trackingEventId);
        storeUserActivity(
          accessToken,
          trackingEventId,
          ACTIVITY_TYPES.BELTS_PURCHASED,
          { beltType: beltTitle, quantity: count, tokenCost: totalTokenCost }
        )
          .then((result) => {
            console.log("✅ Belt purchase activity result:", result);
          })
          .catch((err) => console.warn("❌ Failed to track belt purchase activity:", err));
        // await newBeltConveration();
        successCallBack();
      } else {
        toast.error(
          data.error || "An error occurred during the token-to-belt conversion"
        );
      }
    } catch (error) {
      setShowLoader(false);

      toast.error(error.message);
    }
  }
  // async function newBeltConveration() {
  //   setShowLoader(true);
  //   try {
  //     const data = await beltConvert(accessToken);
  //     if (data.statusCode === 200 || data.statusCode === 201) {
  //       toast.success(data.body.message);
  //     }
  //   } catch (error) {
  //     setShowLoader(false);
  //     toast.error(error.message);
  //   }
  // }
  async function createNewTransaction(accessToken, token, belts, beltType) {
    setShowLoader(true);
    try {
      const data = await createTransaction(accessToken, {
        tokens: token,
        belts,
        beltType,
      });
      if (data.statusCode === 200 || data.statusCode === 201) {
        toast.success(data.body.message);
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  }
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },

    mainView: {
      width: "60%",
      maxWidth: 700,
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: 30,
      marginHorizontal: 40,
      marginVertical: 50,
      alignSelf: "center",
      borderRadius: 12,
      borderColor: AppColors.buttonRed_DC2626,
      borderWidth: 1,
    },
    headerView: {
      marginTop: 16,
      flexDirection: "row",
      justifyContent: "space-between",
      paddingVertical: 10,
      gap: 10,
    },
    tokenWrapper: {
      backgroundColor: AppColors.black_282828,
      borderRadius: 8,
      paddingVertical: 5,
      paddingHorizontal: 16,
      marginTop: 12,
      flexDirection: "row",
      gap: 10,
    },
    tokenItemWrapper: {
      backgroundColor: AppColors.black_121212,
      borderRadius: 6,
      flexDirection: "row",
      gap: 10,
      justifyContent: "center",
      alignItems: "center",
      paddingHorizontal: 10,
      paddingVertical: 5,
    },
    divider: {
      height: 2,
      alignSelf: "center",
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: "100%",
    },
    buttonWrapper: {
      justifyContent: "space-between",
      flexDirection: "row",
      gap: 10,
      marginTop: 20,
      marginBottom: 16,
      // height: 38,
    },
    closeButton: {
      borderRadius: 10,
      marginBottom: 15,
      justifyContent: "center",
      alignItems: "center",
      borderWidth: 2,
      borderColor: AppColors.buttonRed_DC2626,
    },
    confirmButton: {
      backgroundColor: AppColors.buttonRed_DC2626,
      borderRadius: 10,
      marginBottom: 15,
      justifyContent: "center",
      alignItems: "center",
    },
    closeButtonText: {
      paddingVertical: 12,
      paddingHorizontal: 65,
      color: AppColors.white,
    },
    confirmButtonText: {
      paddingVertical: 12,
      paddingHorizontal: 50,
      color: AppColors.white,
    },
    beltWrapper: {
      borderRadius: 8,
      borderWidth: 0.8,
      borderColor: "#374151",
      width: "85%",
      marginTop: 20,
      paddingHorizontal: 25,
      paddingVertical: 20,
    },
    beltSelected: {
      justifyContent: "center",
      alignItems: "center",
      gap: 10,
    },
    beltImage: {
      width: 150,
      height: 200,
      resizeMode: "contain",
    },
    imgArrow: {
      width: 52,
      height: 35,
      resizeMode: "contain",
    },
    confirmImageWrapper: {
      justifyContent: "center",
      alignItems: "center",
      width: 150,
      height: 200,
    },
    confirmImage: {
      width: 120,
      height: 120,
      resizeMode: "contain",
    },
    beltText: {
      fontSize: 24,
      color: AppColors.white,
    },
    counterWrapper: {
      flexDirection: "row",
      alignItems: "center",
      backgroundColor: AppColors.purple_453B50,
      borderRadius: 20,
      width: 151,
      justifyContent: "space-between",
    },
    button: {
      width: 30,
      height: 30,
      borderRadius: 20,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "white",
    },
    disabledButton: {
      backgroundColor: "gray",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "45%",
        maxWidth: 700,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
        borderColor: AppColors.buttonRed_DC2626,
        borderWidth: 1,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      headerView: {
        marginTop: 16,
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 10,
        gap: 10,
      },
      tokenWrapper: {
        backgroundColor: AppColors.black_282828,
        borderRadius: 8,
        paddingVertical: 5,
        paddingHorizontal: 16,
        marginTop: 12,
        flexDirection: "row",
        gap: 10,
      },
      tokenItemWrapper: {
        backgroundColor: AppColors.black_121212,
        borderRadius: 6,
        flexDirection: "row",
        gap: 10,
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal: 10,
        paddingVertical: 5,
      },
      buttonWrapper: {
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 10,
        marginBottom: 16,
        // height: 38,
      },
      closeButton: {
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 2,
        borderColor: AppColors.buttonRed_DC2626,
      },
      confirmButton: {
        backgroundColor: AppColors.buttonRed_DC2626,
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
      },
      closeButtonText: {
        paddingVertical: 12,
        paddingHorizontal: 65,
        color: AppColors.white,
      },
      confirmButtonText: {
        paddingVertical: 12,
        paddingHorizontal: 50,
        color: AppColors.white,
      },

      beltSelected: {
        justifyContent: "center",
        alignItems: "center",
        gap: 10,
      },
      beltImage: {
        width: 150,
        height: 200,
        resizeMode: "contain",
      },
      imgArrow: {
        width: 52,
        height: 35,
        resizeMode: "contain",
      },
      confirmImageWrapper: {
        justifyContent: "center",
        alignItems: "center",
        width: 150,
        height: 200,
      },
      confirmImage: {
        width: 120,
        height: 120,
        resizeMode: "contain",
      },
      beltText: {
        fontSize: 24,
        color: AppColors.white,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "55%",
        maxWidth: 700,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
        borderColor: AppColors.buttonRed_DC2626,
        borderWidth: 1,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      headerView: {
        marginTop: 16,
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 10,
        gap: 10,
      },
      tokenWrapper: {
        backgroundColor: AppColors.black_282828,
        borderRadius: 8,
        paddingVertical: 5,
        paddingHorizontal: 16,
        marginTop: 12,
        flexDirection: "row",
        gap: 10,
      },
      tokenItemWrapper: {
        backgroundColor: AppColors.black_121212,
        borderRadius: 6,
        flexDirection: "row",
        gap: 10,
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal: 10,
        paddingVertical: 5,
      },
      buttonWrapper: {
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 10,
        marginBottom: 16,
        // height: 38,
      },
      closeButton: {
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 2,
        borderColor: AppColors.buttonRed_DC2626,
      },
      confirmButton: {
        backgroundColor: AppColors.buttonRed_DC2626,
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
      },
      closeButtonText: {
        paddingVertical: 12,
        paddingHorizontal: 65,
        color: AppColors.white,
      },
      confirmButtonText: {
        paddingVertical: 12,
        paddingHorizontal: 50,
        color: AppColors.white,
      },

      beltSelected: {
        justifyContent: "center",
        alignItems: "center",
        gap: 10,
      },
      beltImage: {
        width: 150,
        height: 200,
        resizeMode: "contain",
      },
      imgArrow: {
        width: 52,
        height: 35,
        resizeMode: "contain",
      },
      confirmImageWrapper: {
        justifyContent: "center",
        alignItems: "center",
        width: 150,
        height: 200,
      },
      confirmImage: {
        width: 120,
        height: 120,
        resizeMode: "contain",
      },
      beltText: {
        fontSize: 24,
        color: AppColors.white,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "flex-end",
        alignItems: "center",
      },
      mainView: {
        width: "100%",
        height: "80%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 0,
        marginVertical: 0,
        alignSelf: "center",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderColor: AppColors.buttonRed_DC2626,
        borderWidth: 1,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      headerView: {
        marginTop: 16,
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 10,
        gap: 10,
      },
      tokenWrapper: {
        backgroundColor: AppColors.black_282828,
        borderRadius: 8,
        paddingVertical: 5,
        paddingHorizontal: 16,
        marginTop: 12,
        flexDirection: "row",
        gap: 10,
      },
      tokenItemWrapper: {
        backgroundColor: AppColors.black_121212,
        borderRadius: 6,
        flexDirection: "row",
        gap: 10,
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal: 10,
        paddingVertical: 5,
      },
      buttonWrapper: {
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 10,
        marginBottom: 16,
        // height: 38,
      },
      closeButton: {
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 2,
        borderColor: AppColors.buttonRed_DC2626,
      },
      confirmButton: {
        backgroundColor: AppColors.buttonRed_DC2626,
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
      },
      closeButtonText: {
        paddingVertical: 12,
        paddingHorizontal: 65,
        color: AppColors.white,
      },
      confirmButtonText: {
        paddingVertical: 12,
        paddingHorizontal: 50,
        color: AppColors.white,
      },
      beltWrapper: {
        width: "100%",
        paddingHorizontal: 12,
        paddingVertical: 12,
      },
      beltSelected: {
        justifyContent: "center",
        alignItems: "center",
        gap: 10,
      },
      beltImage: {
        width: 150,
        height: 200,
        resizeMode: "contain",
      },
      imgArrow: {
        width: 52,
        height: 35,
        resizeMode: "contain",
      },
      confirmImageWrapper: {
        justifyContent: "center",
        alignItems: "center",
        width: 150,
        height: 200,
      },
      confirmImage: {
        width: 120,
        height: 120,
        resizeMode: "contain",
      },
      beltText: {
        fontSize: 24,
        color: AppColors.white,
      },
      counterWrapper: { width: 113 },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "flex-end",
        alignItems: "center",
      },
      mainView: {
        width: "100%",
        height: "80%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 12,
        marginHorizontal: 0,
        marginVertical: 0,
        alignSelf: "center",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderColor: AppColors.buttonRed_DC2626,
        borderWidth: 1,
      },
      divider: {
        height: 2,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      headerView: {
        marginTop: 16,
        flexDirection: "column",
        justifyContent: "space-between",
        paddingVertical: 10,
        gap: 10,
      },
      tokenWrapper: {
        backgroundColor: AppColors.black_282828,
        borderRadius: 8,
        paddingVertical: 5,
        paddingHorizontal: 16,
        marginTop: 12,
        flexDirection: "row",
        gap: 10,
      },
      tokenItemWrapper: {
        backgroundColor: AppColors.black_121212,
        borderRadius: 6,
        flexDirection: "row",
        gap: 10,
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal: 10,
        paddingVertical: 5,
      },
      buttonWrapper: {
        justifyContent: "center",
        flexDirection: "row",
        gap: 10,
        marginBottom: 16,
        paddingTop: 10,
        marginTop: 0,
        // height: 38,
      },
      closeButton: {
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 2,
        borderColor: AppColors.buttonRed_DC2626,
      },
      confirmButton: {
        backgroundColor: AppColors.buttonRed_DC2626,
        borderRadius: 10,
        marginBottom: 15,
        justifyContent: "center",
        alignItems: "center",
      },
      closeButtonText: {
        paddingVertical: 12,
        paddingHorizontal: 35,
        color: AppColors.white,
      },
      confirmButtonText: {
        paddingVertical: 12,
        paddingHorizontal: 20,
        color: AppColors.white,
      },
      beltWrapper: {
        width: "100%",
        paddingHorizontal: 12,
        paddingVertical: 12,
        marginTop: 0,
      },
      beltSelected: {
        justifyContent: "center",
        alignItems: "center",
        gap: 10,
      },
      beltImage: {
        width: 90,
        height: 110,
        resizeMode: "contain",
      },
      imgArrow: {
        width: 40,
        height: 22,
        resizeMode: "contain",
      },
      confirmImageWrapper: {
        justifyContent: "center",
        alignItems: "center",
        width: 90,
        height: 110,
      },
      confirmImage: {
        width: 75,
        height: 75,
        resizeMode: "contain",
      },
      beltText: {
        fontSize: 18,
        color: AppColors.white,
      },
      counterWrapper: { width: 113 },
    },
  }
);
